export default __webpack_public_path__ + "static/media/b47.bcfdeeba.png";